export default {"src":"/_next/static/media/ad2_mobile.42f767c1.svg","height":809,"width":430,"blurWidth":0,"blurHeight":0};